import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form as soon as a field changes, so inline-edited
// cells persist on blur without a separate save button.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
